// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ac579c {
  overflow: hidden;
  transition: height 300ms ease, opacity 300ms ease-in-out;
}
.e8ba5e {
  padding-bottom: 16px;
}
.e21af5 {
  display: flex;
  column-gap: 16px;
  padding-inline-start: 16px;
  align-items: center;
}
.cdb7db {
  background-color: var(--base-background-success);
}
.e1b625 {
  background-color: var(--base-background-info);
}
.d16620 {
  background-color: var(--base-background-warning);
}
.dc2065 {
  background-color: var(--base-background-error);
}
.d1ca3e {
  flex: 1 1;
  padding: 16px 0;
}
.a769e8 {
  margin-inline-end: 4px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Notifications/BannerNotification/BannerNotification.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,wDAAwD;AAC1D;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,gBAAgB;EAER,0BAA0B;EAClC,mBAAmB;AACrB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,SAAO;EACP,eAAe;AACjB;AACA;EAEU,sBAAsB;AAChC","sourcesContent":[".ac579c {\n  overflow: hidden;\n  transition: height 300ms ease, opacity 300ms ease-in-out;\n}\n.e8ba5e {\n  padding-bottom: 16px;\n}\n.e21af5 {\n  display: flex;\n  column-gap: 16px;\n  -webkit-padding-start: 16px;\n          padding-inline-start: 16px;\n  align-items: center;\n}\n.cdb7db {\n  background-color: var(--base-background-success);\n}\n.e1b625 {\n  background-color: var(--base-background-info);\n}\n.d16620 {\n  background-color: var(--base-background-warning);\n}\n.dc2065 {\n  background-color: var(--base-background-error);\n}\n.d1ca3e {\n  flex: 1;\n  padding: 16px 0;\n}\n.a769e8 {\n  -webkit-margin-end: 4px;\n          margin-inline-end: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
